/**
 * Short unique ID for editor objects (layers, ads, attributes, batch
 * handles, media items, variants, etc.). 10 chars from nanoid's 64-char
 * URL-safe alphabet (A-Z a-z 0-9 _ -), generated with crypto-secure
 * randomness. Collision space is 64^10 ≈ 1.15 × 10^18 — safe for any
 * realistic per-template/per-session use.
 *
 * Pass a prefix to namespace by type:
 *   createUid('text')  → 'text-V1StGXR8z5'
 *   createUid('ad')    → 'ad-9pQrL2mNxK'
 *   createUid()        → 'V1StGXR8z5'
 *
 * Use this for any new client-generated identifier. Reach for
 * `crypto.randomUUID()` directly only when a full RFC 4122 UUID is
 * required by an external system.
 */

import { nanoid } from 'nanoid';

export function createUid(prefix?: string): string {
  const id = nanoid(10);
  return prefix ? `${prefix}-${id}` : id;
}
